export const DOMAIN_BLOCKS = [
  'gab.com',
  'gab.ai'
]
